import {
  getEnvironmentInformation,
  getInfoPopups,
  getSettings,
} from '../../services/api';

export default {
  namespaced: true,

  state: {
    environment: {},
    settings: {},
    switchGearGeneratorUrls: {},
    infoPopups: [],
    includingVat: false,
  },

  actions: {
    async fetchEnvironmentInformation({ commit }) {
      const { environment } = await getEnvironmentInformation();

      commit('setEnvironment', environment || {});
    },
    async fetchSettings({ commit }) {
      const { data } = await getSettings();

      commit('setSettings', data.frontend_settings || {});
    },
    async fetchInfoPopups({ commit }) {
      const { data } = await getInfoPopups();

      commit('setInfoPopups', data.info_popups || {});
    },
  },

  mutations: {
    setEnvironment(state, settings) {
      state.environment = settings;
    },
    setSettings(state, settings) {
      state.settings = settings;
    },
    setInfoPopups(state, infoPopups) {
      state.infoPopups = infoPopups;
    },
    setIncludingVat(state, includingVat) {
      state.includingVat = includingVat;
    },
  },

  getters: {
    getCustomImages(state) {
      const settings = state.settings;
      const backgroundOptions = [];

      const hasImageOne = Boolean(settings.image_one_url);
      const hasImageTwo = Boolean(settings.image_two_url);
      const hasImageThree = Boolean(settings.image_three_url);

      if (hasImageOne) {
        backgroundOptions.push({
          id: 3,
          key: settings.image_1_text,
          value: {
            image: settings.image_one_url,
            contrast: settings.image_1_contrast,
          },
        });
      }

      if (hasImageTwo) {
        backgroundOptions.push({
          id: 4,
          key: settings.image_2_text,
          value: {
            image: settings.image_two_url,
            contrast: settings.image_2_contrast,
          },
        });
      }

      if (hasImageThree) {
        backgroundOptions.push({
          id: 5,
          key: settings.image_3_text,
          value: {
            image: settings.image_three_url,
            contrast: settings.image_3_contrast,
          },
        });
      }

      return backgroundOptions;
    },

    getBackgroundOptions(state, getters) {
      const customBackgroundImages = getters['getCustomImages'];
      let options = [
        {
          id: 1,
          key: 'Eigen afbeelding',
          value: {
            type: 'custom',
            image: null,
            contrast: 'light',
          },
        },
        {
          id: 2,
          key: 'Wit',
          value: {
            image: 'wall-base-white.png',
            contrast: 'light',
          },
        },
        {
          id: 3,
          key: 'Grijs',
          value: {
            image: 'wall-gray-dark.jpg',
            contrast: 'dark',
          },
        },
      ];

      if (customBackgroundImages.length === 1) {
        return [...options, ...customBackgroundImages];
      }

      if (customBackgroundImages.length > 1) {
        return customBackgroundImages;
      }

      return options;
    },

    getEnvironmentLocale(state) {
      if (
        !state.environment ||
        typeof state.environment.country_code !== 'string'
      ) {
        return null;
      }

      return state.environment.country_code.toLowerCase();
    },
    findInfoPopupByKey: (state) => (key) => {
      return state.infoPopups.find((popup) => popup.key === key) || null;
    },
  },
};
